import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import {
  ValuationStepData,
  PropertyValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
import { Message, MessageType } from '@/interfaces/app/Message'
import createMessage from '@/services/app/createMessage'

export default class PropertyValuationStepValidator extends ValuationStepValidator {
  public isValid: boolean = false

  public validate(data: ValuationStepData): Message[] {
    const stepData = data as PropertyValuationStepData
    const errors: Message[] = []

    if (stepData.propertyType === PropertyType.House) {
      const message = createMessage(
        'Krok 1 - V současnosti není možné valuovat rodinné domy. Vyberte prosím byt.',
        MessageType.Error
      )
      errors.push(message)
    }

    if (!this.enumContains(PropertyType, stepData.propertyType)) {
      const message = createMessage(
        'Krok 1 - Nesprávně zvolený typ nemovitosti',
        MessageType.Error
      )
      errors.push(message)
    }

    if (errors.length === 0) {
      this.isValid = true
      return [createMessage('Krok 1 je vyplněný správně', MessageType.Success)]
    } else {
      this.isValid = false
      return errors
    }
  }
}
